import { render, staticRenderFns } from "./PopUpTooltip.vue?vue&type=template&id=10cea96a&scoped=true&"
import script from "./PopUpTooltip.vue?vue&type=script&lang=js&"
export * from "./PopUpTooltip.vue?vue&type=script&lang=js&"
import style0 from "./PopUpTooltip.vue?vue&type=style&index=0&id=10cea96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cea96a",
  null
  
)

export default component.exports